import MockTestResultsHooks from "../../../Hooks/Mock/Student/MockTestResultsHooks";

const AttemptCard = (Props) => {
  const [obtained, total] = Props.score.split("/").map(Number);
  const isSuccess = obtained / total >= 0.5;

  const MockTestResultsHks = MockTestResultsHooks();

  const formattedDate = (() => {
    const date = new Date(Props.date);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  })();

  const handleView = (test) => {
    let data =
      typeof test.attempteddata === "string"
        ? JSON.parse(test.attempteddata)[Props.attemptNo - 1]
        : test.attempteddata[Props.attemptNo - 1];
    console.log("data:",data);
    
    data.viewtest = 0;
    data.autoeval = 0;
    data.withAI = test.aiMode;
    data.id = test.tid || test.lpid;
    data.name = test.name || test.lpname;
    data.lp = test.hasOwnProperty("lpid");
    data.libtype = test.libtype || test.types;

    return MockTestResultsHks.handleView(data);
  };
  // console.log("Props:",Props,Props.mockReportClick);
  
  return (
    <div className="attemptCard" onClick={() => Props.mockReportClick ? Props.mockReportClick({testData:Props.test,attemptNo:Props.attemptNo - 1}): handleView(Props.test)}>
      <div className="attemptCardLeft">
        <p className="attemptCardName">Attempt {Props.attemptNo}</p>
        <p className="attemptCardDate">{formattedDate}</p>
      </div>
      <div className={`attemptCardRight ${isSuccess ? "success" : "error"}`}>
        <p>{Props.score}</p>
      </div>
    </div>
  );
};

export default AttemptCard;
